import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import ButtonsConstructor from "../../components/shared/Input/Button/ButtonsConstructor";
import { E_BoxRoute_Action, E_Route } from "../../models/constants/Enum_Routes";
import MessageModal from "../../components/shared/Modal/MessageModal";

class OpenBoxPage extends Component {
	render({className, style}) {
		return (
			<section className={combineClasses("open-box-page", className)} style={style}>
				<hr/>

				<nav className={"action-buttons"}>
					<ButtonsConstructor buttons={[
						{
							icon: "stop-circle",
							text: "box.open.end",
							action: () => this._openWarningModal(),
						},
						{
							icon: "sync-alt",
							text: "box.open.repeated",
							href: E_Route.OPEN_BOX_PIN(E_BoxRoute_Action.OPEN),
						}
					]}/>
				</nav>
			</section>
		);
	}

	_openWarningModal() {
		window.modal.open(
			<MessageModal
				icon={"stop-circle"}
				iconProps={{style: {color: "var(--warning-color)"}}}
				title={"box.open.end.title"}
				message={"box.open.end.message"}
				actionButtons={(defaultButtons) => [
					{
						...defaultButtons[0],
						text: "cancel",
					},
					{
						text: "ok",
						className: "confirm",
						href: E_Route.OPEN_BOX_PIN(E_BoxRoute_Action.RETRIEVE),
						action: () => window.modal.close(),
					}
				]}
			/>,
		)
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,
		}
	}
}

export default OpenBoxPage;
